import React from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";


const MapLocationComponent = ({ lat, lng }) => {

    const containerStyle = {
        width: "100%",
        height: "400px",
    };
    const center = {
        lat: lat,
        lng: lng,
    };
    return (
        <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={18}>
            <Marker position={center} />
        </GoogleMap>
    );
};

export default MapLocationComponent;
